"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _bindStorageItem = _interopRequireDefault(require("../__internal__/bindStorageItem"));

var _Browser = require("../Browser");

var _enums = require("../enums");

var getStorage = (0, _Browser.ifBrowserThen)(function (type) {
  switch (type) {
    case _enums.STORAGE.local:
      {
        return window.localStorage;
      }

    case _enums.STORAGE.session:
      {
        return window.sessionStorage;
      }

    default:
      {
        console.error("The type '".concat(type, "' is invalid, using localStorage as default"), "\n", "The following types are available:", "local, session");
        return window.localStorage;
      }
  }
});
/**
 * Helps you manipulate localStorage and sessionStorage safely (isomorphic)
 */

var browserStorage = function browserStorage(type) {
  var storage = getStorage(type);
  return {
    /**
     * Binds a key
     * @example
     * const storage = browserStorage().bindItem('test')
     *
     * storage.set('testing') // => browserStorage().set('test', 'testing')
     * storage.get() // => browserStorage().get('test')
     */
    bindItem: function bindItem(key) {
      return (0, _bindStorageItem["default"])(browserStorage(type), key);
    },

    /**
     * Deletes the item in the storage
     */
    "delete": (0, _Browser.ifBrowserThen)(function (key) {
      return storage.removeItem(key);
    }),

    /**
     * Clears the Storage
     */
    empty: (0, _Browser.ifBrowserThen)(function () {
      return storage.clear();
    }),

    /**
     * @returns returns what's stored
     */
    get: (0, _Browser.ifBrowserThen)(function (key) {
      var value = storage.getItem(key);
      if (!value) return value;

      try {
        return JSON.parse(value);
      } catch (err) {
        console.error("Error trying to json parse the value");
        return value;
      }
    }),

    /**
     * Sets a new value
     */
    set: (0, _Browser.ifBrowserThen)(function (key, value) {
      return storage.setItem(key, JSON.stringify(value));
    }),

    /**
     * Returns the length of the storage
     */
    size: (0, _Browser.ifBrowserThen)(function () {
      return storage.length;
    })
  };
};

var _default = browserStorage;
exports["default"] = _default;